var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['services'])?_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/app/inventory/services"}},[_c('fa-icon',{attrs:{"icon":"shopping-basket"}}),_vm._v(" Services ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }